import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import * as orgRepo from "@/stores/organizations/repository";
import { useOrganizationContext } from "@/lib/context/OrganizationContext";

interface ResendInviteParams {
  inviteId: number;
}

export const useResendInvite = () => {
  const queryClient = useQueryClient();
  const { currentOrganization } = useOrganizationContext();

  return useMutation({
    mutationFn: async ({ inviteId }: ResendInviteParams) => {
      return orgRepo.resendInvite(inviteId);
    },
    onSuccess: () => {
      // Invalidate organization invites query to refetch
      queryClient.invalidateQueries({
        queryKey: ["organization-invites", currentOrganization?.id],
      });
      toast.success("Invitation resent successfully!");
    },
    onError: (error: Error) => {
      toast.error(error.message || "Failed to resend invitation");
    },
  });
};
